(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'nestedPage', {
            bindings: {
                content:    '<',
                metadata:   '<',
                expanded:   '<'
            },
            templateUrl:  'app/views/partials/layout/nested-page.html',
            controller:   NestedPageController,
            controllerAs: 'vm'
        });


    /**
     * @type {ng.IController}
     */
    function NestedPageController(){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        // Methods
        vm.toggleContent = toggleContent;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        //vm.$onInit = function() {};



        vm.$onChanges = function( changesObject ) {

            // Expand panel (if required) when content changes (indicates a new ested page has been bound).
            if ( changesObject.content && changesObject.content.currentValue ) {
                vm.isOpened = ( angular.isDefined( vm.expanded ) && vm.expanded === 'true' ) ? vm.expanded : false;
            };
        }





        /* ===== PUBLIC METHODS ============================================= */


        /**
         * Toggles (expands or collapses) panel with major's content.
         */
        function toggleContent() {
            vm.isOpened = !vm.isOpened;
        }



    }
})();
